var getAjaxPics = function($ajaxHolder, mode) {
    // console.log(mode);

    if ($ajaxHolder.length) {

        var lang = $ajaxHolder.data('lang');
        var sysLanguageUid = $ajaxHolder.data('syslanguageuid');
        if (lang == "cz") {
            lang = "cs";
        }
        var $pics = $ajaxHolder.find('.pics');

        $.ajax({
            method: 'POST',
            url: "/?id=" + rootPage + "&L=" + sysLanguageUid + "&type=1723",
            data: {
                lang: $ajaxHolder.data('lang'),
                sysLanguageUid: $ajaxHolder.data('syslanguageuid'),
                getPage: $ajaxHolder.data('nextpage'),
                type: $ajaxHolder.data('type'),
                albumID: $ajaxHolder.data('albumid'),
                singlePicDl: $ajaxHolder.data('singlepicdownload'),
                zipPicDl: $ajaxHolder.data('zippicdownload'),
                imageZoom: $ajaxHolder.data('imagezoom'),
                falImages: $ajaxHolder.data('falimages'),
                pid: $ajaxHolder.data('pid')
            },
            beforeSend: function(xhr, o) {

                //console.log('BEFORE');
                //console.log(o);
                //console.log(xhr);
                $ajaxHolder.addClass('loading');
            },
            success: function(response, status, xhr) {

                //console.log('SUCCESS');
                //console.log(response);
                //console.log(status);
                //console.log(xhr);

                var $response = $(response);
                $pics.append($response);

                // Tooltips der nachgeladenen Bilder initialisieren (Init ist idempotent)
                $pics.find('.js-tooltip').each(function() {
                    accessibleSimpleTooltipAria.apply(this);
                });

                if ($pics.find('.noNewPicsAnyMore').length) {
                    // console.log("%cTTG Debug", "background: #0080a3; color: #fff; font-family: 'Rubik'; padding: 5px;", 'No Further Pics > del ".loadMore"');
                    $('#ttg_bildergalerie .loadMore, #ttg_bildergalerie .loadMoreRemoved').remove();
                } else {
                    // console.log("%cTTG Debug", "background: #0080a3; color: #fff; font-family: 'Rubik'; padding: 5px;", 'there are more pics > removeClass ".loadMoreRemoved"');
                    $('#ttg_bildergalerie a.loadMoreRemoved').addClass('loadMore').removeClass('loadMoreRemoved');
                }

                if (mode === 'init') {

                    $pics.masonry({
                        itemSelector: '.grid-item',
                        columnWidth: '.grid-sizer',
                        percentPosition: true
                    });

                } else {

                    $pics.masonry('appended', $response);

                }

                $('.zipDownload').removeClass('hide');

            },
            error: function(xhr, status, error) {

                //console.log('ERROR');
                //console.log(xhr);
                //console.log(status);
                //console.log(error);

            },
            complete: function(xhr, status) {

                //console.log('COMPLETE');
                //console.log(xhr);
                //console.log(status);

                $pics.imagesLoaded().progress(function(instance, image) {
                    $(image.img).closest('.grid-item').addClass('loaded');
                }).always(function(instance) {
                    $pics.masonry('layout');
                    $ajaxHolder.removeClass('loading');
                });

                // Count Up DATA-Attributes for infinite Scroll
                $ajaxHolder.data('nextpage', parseInt($ajaxHolder.data('nextpage')) + 1);
                $ajaxHolder.data('currentpage', $ajaxHolder.data('nextpage'));

                // INIT ENDLESS SCROLLING
                if (mode === 'init' && $ajaxHolder.data('endless') == "1") {
                    setTimeout(function(e) {
                        var scrollMagicCtrl, scene;
                        scrollMagicCtrl = new ScrollMagic.Controller();
                        scene = new ScrollMagic.Scene({
                            triggerElement: '#ttg_bildergalerie .loadMore',
                            offset: -380
                        }).addTo(scrollMagicCtrl).on('enter', function(e) {
                            $('#ttg_bildergalerie .loadMore').trigger('click');
                        });
                    }, 1500);
                }
            }
        });

    }
};

// PLUGIN TTG BILDERGALERIE
var nextElement = $(".tx-ttg-bildergalerie").data("next-element");
var previousElement = $(".tx-ttg-bildergalerie").data("previous-element");
var close = $(".tx-ttg-bildergalerie").data("close");

getAjaxPics($('#ttg_bildergalerie .ajaxHolder'), 'init');

$('#ttg_bildergalerie .loadMore').click(function(e) {
    e.preventDefault();
    getAjaxPics($('#ttg_bildergalerie .ajaxHolder'), 'append');
});
